export const AllowsPayload = {
    POST: true,
    PUT: true,
    PATCH: true,
    DELETE: true,
};
//# sourceMappingURL=allows_payload.js.map